<!-- src/lib/components/sections/faq-section.svelte -->
<script lang="ts">
	interface FaqItem {
		question: string;
		answer: string;
	}

	let {
		items,
		title = 'Questions fréquentes'
	}: {
		items: FaqItem[];
		title?: string;
	} = $props();

	let openIndex = $state<number | null>(null);

	function toggle(i: number) {
		openIndex = openIndex === i ? null : i;
	}
</script>

<section class="py-12 sm:py-16 md:py-20">
	<div class="container mx-auto px-4 sm:px-6 lg:px-12">
		<!-- Header -->
		<div class="mb-10 text-center">
			<span
				class="rounded-full bg-juslin-gold/10 px-4 py-2 text-xs font-semibold
                   tracking-widest text-juslin-gold uppercase"
			>
				FAQ
			</span>
			<h2 class="mt-4 text-2xl font-bold text-foreground sm:text-3xl md:text-4xl">
				{title}
			</h2>
		</div>

		<!-- Items -->
		<div class="mx-auto max-w-3xl space-y-3">
			{#each items as item, i}
				<div
					class="overflow-hidden rounded-xl border border-border bg-card/50
                    transition-all duration-200
                    {openIndex === i ? 'border-juslin-gold/30' : 'hover:border-border/80'}"
				>
					<!-- Question -->
					<button
						onclick={() => toggle(i)}
						class="flex w-full items-center justify-between gap-4 px-5 py-4
                   text-left transition-colors hover:bg-card/80"
						aria-expanded={openIndex === i}
					>
						<span class="text-sm font-semibold text-foreground sm:text-base">
							{item.question}
						</span>
						<span
							class="shrink-0 text-juslin-gold transition-transform duration-300
                         {openIndex === i ? 'rotate-45' : ''}"
						>
							<svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M12 4v16m8-8H4"
								/>
							</svg>
						</span>
					</button>

					<!-- Answer -->
					{#if openIndex === i}
						<div class="px-5 pb-4">
							<p class="text-sm leading-relaxed text-muted-foreground sm:text-base">
								{item.answer}
							</p>
						</div>
					{/if}
				</div>
			{/each}
		</div>
	</div>
</section>
